import { isLocalOrDevEnv } from '@/utils/helpers/env.ts'
import { useContextGenericFolders } from '@/composables/context/ctx-generics'
import type { NodePolicy, PathSegment } from '@deepcloud/api-deep-box'

type NodeWithPolicy = { nodeId: string; policy: NodePolicy }

export function useBoxArchive() {
  const genericFolders = useContextGenericFolders()

  const archiveFolder = computed(() =>
    isLocalOrDevEnv()
      ? genericFolders.value.find((g) => g.id === 'archive')
      : undefined,
  )

  function isArchiveNode(node: { nodeId: string }) {
    return !!archiveFolder.value && node.nodeId === archiveFolder.value.nodeId
  }

  function isArchivePath(segments: PathSegment[] = []) {
    return segments.some(isArchiveNode)
  }

  function lockNodeRemoval(node: NodeWithPolicy) {
    node.policy.canDelete = false
    node.policy.canMoveWithinBox = false
    node.policy.canMoveOutOfBox = false
  }

  // frontend-only guard: the API still allows removing the archive or anything inside it
  function lockArchiveRemoval(
    nodes: NodeWithPolicy[] = [],
    segments: PathSegment[] = [],
  ) {
    const archiveIndex = segments.findIndex(isArchiveNode)
    const isInsideArchive = archiveIndex !== -1

    if (isInsideArchive) {
      segments.slice(archiveIndex).forEach(lockNodeRemoval)
    }
    nodes
      .filter((n) => isInsideArchive || isArchiveNode(n))
      .forEach(lockNodeRemoval)
  }

  return {
    archiveFolder,
    isArchiveNode,
    isArchivePath,
    lockNodeRemoval,
    lockArchiveRemoval,
  }
}
